/** @format */

import { makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import Pager from '../../../../components/Adescom/Pager';
import AddButton from '../../../../components/Buttons/AddButton';
import RemoveButton from '../../../../components/Buttons/RemoveButton';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import TableHeaderContentCell from '../../../../components/Table/TableHeaderContentCell';
import { configDefault } from '../../../../core/config';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { roles, UserRoleHelper } from '../../../../helpers/UserRoleHelper';
import { PrefixCollectionInterface } from '../../../../interfaces/api/PrefixCollectionInterface';
import PrefixInterface from '../../../../interfaces/billing/PrefixInterface';
import PricelistSchemaElementInterface from '../../../../interfaces/billing/PricelistSchemaElementInterface';
import Filter from '../../../../interfaces/forms/Filter';
import Order from '../../../../interfaces/forms/Order';
import { prefixesConstants, prefixesReducers, prefixesReducersType } from '../../../../modules/prefixes/reducers';
import { store } from '../../../../core/store';
import { GeneralHelper } from '../../../../helpers/GeneralHelper';
import oplAppStyle from '../../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import FakePagination from '../../../../components/Pagination/FakePagination';

interface PricelistSchemaElementPrefixesProps {
    classes: any;
    setPrefixes: (fractions: Array<PrefixInterface>) => void;
    selectedPrefixes: Array<PrefixInterface>;
    entity: PricelistSchemaElementInterface;
}

store.injectReducer('prefixesReducers', prefixesReducers, true);
const PricelistSchemaElementPrefixes = (props: PricelistSchemaElementPrefixesProps): React.ReactElement => {
    const dispatch = useDispatch();
    const PREFIX_ES_URI = '/prefixes';

    const [orders, setOrders] = useState<Array<Order>>([]);
    const [filters, setFilters] = useState<Array<Filter>>([]);

    const [assignmentPrefixFilters, setAssignmentPrefixFilters] = useState<Array<Filter>>([]);
    const [assignmentPrefixOrders, setAssignmentPrefixOrders] = useState<Array<Order>>([{ name: 'prefix', value: 'asc' }]);
    const [filteredPrefixes, setFilteredPrefixes] = useState<Array<PrefixInterface>>(props.selectedPrefixes);
    const [afterFirstTimeFill, setAfterFirstTimeFill] = useState<boolean>(false);

    const { selectedPrefixes, setPrefixes, classes } = props;

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };

    const { collections } = useSelector((state: { prefixesReducers: prefixesReducersType }) => {
        return state.prefixesReducers;
    });

    const addPrefixes = (param: { el: PrefixInterface }): void => {
        if (
            !selectedPrefixes.some((pf: PrefixInterface) => {
                return pf.id === param.el.id;
            })
        ) {
            let newArr = [...selectedPrefixes, param.el];
            setPrefixes(newArr);
        }
    };
    const removePrefixes = (param: { el: PrefixInterface }): void => {
        let newArr = [...selectedPrefixes];
        selectedPrefixes.forEach((el: PrefixInterface, indx: number) => {
            if (el.id === param.el.id) {
                newArr.splice(indx, 1);
            }
        });
        setPrefixes(newArr);
    };

    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(PREFIX_ES_URI, configDefault.PLATFORM_API_PREFIX)),
            prefixesConstants.LIST,
            [{ name: 'type', value: props.entity.type }, ...filters],
            orders,
            (data: any) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    }, [dispatch, props.entity.type, orders, filters]);

    const paginationCallbackFunction = (uri: string | null): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath(PREFIX_ES_URI, configDefault.PLATFORM_API_PREFIX);
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(FormGeneralHelper.getByUri(uri), prefixesConstants.LIST, [], [], (data: PrefixCollectionInterface) => {}, {
            propagateDataToCallback: false,
            dispatchAfterCallback: true,
        });
    };

    const updateOrderList = (orders: Array<Order>): void => {
        setOrders(orders);
    };
    const updateFilterList = (filters: Array<Filter>): void => {
        setFilters(filters);
    };

    const handleSetAssignmentPricelistSchemaElementOrders = (orders: Array<Order>): void => {
        setAssignmentPrefixOrders(orders);
        setFilteredPrefixes(
            filteredPrefixes.sort((a, b) =>
                GeneralHelper.sort(a, b, orders[0].name, orders.length > 0 && typeof orders[0].value === 'string' ? orders[0].value : 'asc')
            )
        );
    };
    const handleSetAssignmentPricelistSchemaElementFilters = (filters: Array<Filter>): void => {
        setAssignmentPrefixFilters(filters);
    };

    const filterAssignedPrefixes = useCallback(() => {
        if (assignmentPrefixFilters.length > 0) {
            const x = props.selectedPrefixes.filter((value: PrefixInterface) => {
                const isOkArr: Array<boolean> = [];

                assignmentPrefixFilters.forEach((el: any) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    //@ts-ignore
                    if (value[el.name].toLowerCase().includes(el.value.toLowerCase())) {
                        isOkArr.push(true);
                    } else {
                        isOkArr.push(false);
                    }
                });
                return !isOkArr.includes(false);
            });
            setFilteredPrefixes(x);
        } else {
            setFilteredPrefixes(props.selectedPrefixes);
        }
    }, [assignmentPrefixFilters, props.selectedPrefixes]);

    useEffect(() => {
        if (props.selectedPrefixes && props.selectedPrefixes.length > 0 && !afterFirstTimeFill) {
            setFilteredPrefixes(props.selectedPrefixes);
            setAfterFirstTimeFill(true);
        }
    }, [props.selectedPrefixes, filteredPrefixes, afterFirstTimeFill]);

    useEffect(() => {
        let timer = setTimeout(filterAssignedPrefixes, 500);
        return (): void => {
            clearTimeout(timer);
        };
    }, [assignmentPrefixFilters, filterAssignedPrefixes]);

    return (
        <GridContainer>
            <GridItem xs={6} style={{ overflowX: 'scroll' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prefixes:h.prefix_name"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="mainname"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prefixes:h.prefix"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="prefix"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections &&
                            collections['hydra:member'].map((el: PrefixInterface) => {
                                return (
                                    <TableRow key={el.id}>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                <AddButton
                                                    tooltipTitle="pricelists:button.assign_prefix"
                                                    callback={addPrefixes}
                                                    callbackParam={{ el: el }}
                                                    disabled={selectedPrefixes.some((sf: PrefixInterface) => {
                                                        return sf.id === el.id;
                                                    })}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {el.mainname}
                                        </TableCell>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {el.prefix}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell classes={tableCellRoot} colSpan={4}>
                                {collections && collections['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunction} views={collections['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </GridItem>
            <GridItem xs={6} style={{ overflowX: 'scroll' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prefixes:h.prefix_name"
                                    updateOrderList={handleSetAssignmentPricelistSchemaElementOrders}
                                    updateFilterList={handleSetAssignmentPricelistSchemaElementFilters}
                                    fieldName="mainname"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={assignmentPrefixFilters}
                                    sort={assignmentPrefixOrders}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prefixes:h.prefix"
                                    updateOrderList={handleSetAssignmentPricelistSchemaElementOrders}
                                    updateFilterList={handleSetAssignmentPricelistSchemaElementFilters}
                                    fieldName="prefix"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={assignmentPrefixFilters}
                                    sort={assignmentPrefixOrders}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <FakePagination>
                            {filteredPrefixes &&
                                filteredPrefixes.map((el: PrefixInterface) => {
                                    return (
                                        <TableRow key={el.id}>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                    <RemoveButton
                                                        tooltipTitle="pricelists:button.remove_assigned_prefix"
                                                        callback={removePrefixes}
                                                        callbackParam={{ el: el }}
                                                        disabled={
                                                            !selectedPrefixes.some((sf: PrefixInterface) => {
                                                                return sf.id === el.id;
                                                            })
                                                        }
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {el.mainname}
                                            </TableCell>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {el.prefix}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </FakePagination>
                    </TableBody>
                </Table>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(PricelistSchemaElementPrefixes);
